export default __webpack_public_path__ + "static/media/chalk-pointer-left-hand.56862f87.png";